const {bind, unbind} = require('../lib/bind')
const Upload = require('./upload')
const Poll = require('./poll')

class DragDrop {
  constructor(element) {
    this.element = element
    this.dragElement = document.body
    this.eventsAdded = false

    this.boundCancelEvents = this.cancelEvents.bind(this)
    this.boundOnDragOver = this.onDragOver.bind(this)
    this.boundOnDragOff = this.onDragOff.bind(this)
    this.boundOnDrop = this.onDrop.bind(this)

    this.isAdvancedUpload = function() {
      const div = document.createElement('div')
      return (('draggable' in div) || ('ondragstart' in div && 'ondrop' in div)) && 'FormData' in window && 'FileReader' in window
    }()

    this.progressSupported = function() {
      const xhr = new XMLHttpRequest();
      return xhr && ('upload' in xhr) && ('onprogress' in xhr.upload);
    }()

    if (!element) {
      return false
    }

    this.showElement()
  }

  cancelEvents(e) {
    e.preventDefault()
    e.stopPropagation()
  }

  addEvents() {
    if (!this.eventsAdded) {
      bind(this.dragElement, 'drag dragstart dragend dragover dragenter dragleave drop', this.boundCancelEvents)
      bind(this.dragElement, 'dragover dragenter', this.boundOnDragOver)
      bind(this.dragElement, 'dragleave dragend drop', this.boundOnDragOff)
      bind(this.dragElement, 'drop', this.boundOnDrop)

      this.eventsAdded = true
    }
  }

  removeEvents() {
    if (this.eventsAdded) {
      unbind(this.dragElement, 'drag dragstart dragend dragover dragenter dragleave drop', this.boundCancelEvents)
      unbind(this.dragElement, 'dragover dragenter', this.boundOnDragOver)
      unbind(this.dragElement, 'dragleave dragend drop', this.boundOnDragOff)
      unbind(this.dragElement, 'drop', this.boundOnDrop)

      this.eventsAdded = false
    }
  }

  onDragOver(e) {
    this.dragElement.classList.add('is-dragover')
  }

  onDragOff(e) {
    this.dragElement.classList.remove('is-dragover')
  }

  showElement() {
    const dropElement = document.querySelector('.js-upload-dropzone')
    dropElement.classList.add('d-flex')
    dropElement.classList.remove('d-none')

    dropElement.querySelector('.js-upload-pdf-error').classList.remove('active')

    this.addEvents()
  }

  hideElement() {
    const dropElement = document.querySelector('.js-upload-dropzone')
    dropElement.classList.remove('d-flex')
    dropElement.classList.add('d-none')

    this.removeEvents()
  }

  onDrop(e) {
    if (this.isValidDragFile(e)) {
      const upload = new Upload(this)
      upload.setFile(e.dataTransfer.files[0])
      upload.start()
    } else {
      showError()
    }
  }

  showError(textError) {
    this.dragElement.classList.add('is-drop-error')
    setTimeout(function() {
      this.dragElement.classList.remove('is-drop-error')
    }.bind(this), 700)
    if (textError === undefined) textError = 'Ooops something went wrong.'

    let errorUploadDiv = document.querySelector('.js-upload-pdf-error')
    errorUploadDiv.textContent = textError
    errorUploadDiv.classList.add('active')
  }

  isValidDragFile(e) {
    const files = e.dataTransfer.files
    return files.length == 1 && files[0].type == "application/pdf"
  }
}

module.exports = DragDrop;
